export const useDefaultData = () => {

    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFormScreen = {
        idrate: '',
        descripcion: '',
        costo: ''
    }

    return Object.freeze({
        defaultDataModal,
        defaultFormScreen
    })
}